<template>
	<div
		class="banner-upload"
		v-loading="loading"
		element-loading-text="图片上传中"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-tooltip
			effect="dark"
			content="上传成功!"
			placement="top"
			v-model="tooltipShow"
			:manual="true">
			<p></p>
		</el-tooltip>
		<p class="error-msg" v-show="uploadError">上传失败,请重新上传!</p>
		<div v-if="previewSrc === ''" class="banner-add el-icon-plus" @click="uploadHandler"></div>
		<div v-else class="img-preview-block" @mouseover="imgMouseOver" @mouseout="imgMouseOut">
			<w-image :src="previewSrc" alt="" class="img-preview" @click="uploadHandler"></w-image>
			<div class="img-btn" v-show="activeFlag">
				<el-button type="primary" size="mini" class="img-el-button" @click="uploadHandler"><i class="el-icon-upload"></i></el-button>
				<el-button type="danger" size="mini" class="img-el-button" @click="deleteClick"><i class="el-icon-delete"></i></el-button>
			</div>
		</div>
		<input type="file" ref="file" id="file" accept="image/png,image/jpeg,image/jpg,image" v-show="false" @change="getFile">
	</div>
</template>

<script>
export default {
	name: 'imgUpload',
	props: {
		imgSrc: {
			type: String,
			default: ''
		},
		uploadError: Boolean,
		// from: String,
		imgId: {
			type: String,
			default: '0'
		},
		location: Number
		// hasFile: String
		// editDisable: {
		// 	type: Boolean,
		// 	default: false
		// },
		// quaEditDisable: {
		// 	type: Boolean,
		// 	default: false
		// }
	},
	data () {
		return {
			previewSrc: '',
			uploadType: new RegExp(/image\/png|image\/jpg|image\/jpeg/),
			uploadTypeText: 'png,jpg,jpeg',
			uploadSize: 1,
			activeFlag: false,
			loading: false,
			tooltipShow: false,
			tooltipTimer: null,
			fileFiles: ''
		}
	},
	created () {
		this.previewSrc = this.imgSrc
		// console.log(this.from)
	},
	watch: {
		imgSrc (val) {
			this.previewSrc = val
			this.$refs.file.value = ''
			this.$emit('update:uploadError', false)
		}
	},
	methods: {
		imgMouseOver () {
			this.activeFlag = true
		},
		imgMouseOut () {
			this.activeFlag = false
		},
		uploadHandler () {
			this.$refs.file.click()
		},
		getFile (e) {
			this.$emit('update:uploadError', false)
			this.fileFiles = this.$refs.file.files[0]
			let files = e.target.files[0]
			let type = files.type
			let size = files.size / 1024 / 1024
			if (!this.uploadType.test(type)) {
				this.$message.error(`上传图片只支持${this.uploadTypeText}格式!`)
				return false
			}
			if (size > this.uploadSize) {
				this.$message.error(`上传图片大小不能超过${this.uploadSize}M!`)
				// this.$refs.file.value = ''
				// this.previewSrc = ''
				// this.$emit('update:imgSrc', '')
				// this.$emit('update:hasFile', '0')
				// this.$emit('update:uploadError', false)
				return false
			}
			if (!e || !window.FileReader) {
				return false
			}
			let reader = new FileReader()
			reader.readAsDataURL(files)
			reader.onloadend = () => {
				let image = new Image()
				image.src = reader.result
				image.onload = () => {
					// if (image.width !== 750 && image.height !== 266) {
					// 	this.$message.error('请上传符合规定的广告图！')
					// 	this.$refs.file.value = ''
					// 	this.previewSrc = ''
					// 	return false
					// }
					// this.previewSrc = reader.result
					this.uploadImgHandler()
				}
			}
		},
		deleteClick () {
			this.$emit('deletImg', this.location, this.imgSrc)
			// this.$confirm('一经删除无法恢复，是否继续？', '提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	type: 'warning',
			// 	closeOnClickModal: false
			// }).then(() => {
			// }).catch(() => {
			// })
		},
		uploadImgHandler () {
			this.$emit('uploadNewImg', this.imgSrc, this.location)
		}
	}
}
</script>
<style lang="stylus" scoped>
/deep/.el-loading-mask {
	height: 100px
	margin-top: 20px
	border-radius: 6px;
}
// .license-class {
// 	width: 375px!important
// 	height: 200px!important
// 	.banner-add,.img-preview-block {
// 		width: 375px!important
// 		height: 180px!important
// 		line-height: 180px!important
// 	}
// 	/deep/.el-loading-mask {
// 		height: 180px
// 		margin-top: 20px
// 		border-radius: 6px;
// 	}
// }
.banner-upload {
	width: 100px;
	height: 100px;
	border-radius: 6px;
	overflow: hidden;
	box-sizing:border-box
	position:relative
	margin-bottom:10px
	margin-right: 20px
	float left
	.error-msg {
		color:red
		position:absolute
		top:0
		left:0
	}
	.banner-add,.img-preview-block {
		border-radius: 6px;
		overflow: hidden;
		box-sizing:border-box
		width: 100px;
		height: 100px;
		line-height: 100px;
		display: inline-block
	}
	.banner-add {
		border: 1px dashed #d9d9d9;
		cursor: pointer;
		position: relative;
		text-align: center;
		font-size: 28px;
		color: #8c939d;
		&:hover {
			border-color: var(--fx-primary-color);
		}
	}
	.img-el-button {
		padding: 6px 10px
	}
	.img-preview-block {
		position:relative
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		.img-preview {
			width:100%
			height:100%
		}
		.img-btn {
			position: absolute
			top:0px
			right:0px
			height:100%
			width:100%
			background-color:rgba(0,0,0,0.1)
			text-align center
		}
	}
}
</style>
